// expected to look like: "workspace/{workspaceId}/document/{documentId}".
export const parseWorkspaceDocumentEntityPath = (entityPath: string) => {
  const match = entityPath.match(/^workspace\/([^/]+)\/document\/([^/]+)$/);

  if (!match) {
    throw new Error(`Invalid entityPath format: ${entityPath}`);
  }

  const [, workspaceId, documentId] = match;

  return { workspaceId, documentId };
};

// expected to look like: "legislation/{externalId}/datasource/{datasource}".
export const parseLegislationEntityPath = (entityPath: string) => {
  const match = entityPath.match(
    /^legislation\/([^/]+)\/datasource\/([^/]+)$/
  );

  if (!match) {
    throw new Error(`Invalid legislation entityPath format: ${entityPath}`);
  }

  const [, externalId, datasource] = match;
  return { externalId, datasource };
};

// expected to look like: "workspace/{workspaceId}".
export const parseWorkspaceEntityPath = (entityPath: string) => {
  const match = entityPath.match(/^workspace\/([^/]+)$/);

  if (!match) {
    throw new Error(`Invalid entityPath format: ${entityPath}`);
  }

  const [, workspaceId] = match;
  return { workspaceId };
};

// expected to look like: "workspace/{workspaceId}/folder/{folderName}" or "workspace/{workspaceId}/folder/{folderName}/{folderName}/..." or "workspace/{workspaceId}/folder/".
export const parseWorkspaceFolderEntityPath = (entityPath: string) => {
  const match = entityPath.match(/^workspace\/([^/]+)\/folder\/(.*)$/);
  if (!match) {
    throw new Error(`Invalid entityPath format: ${entityPath}`);
  }

  const [, workspaceId, folderPath] = match;

  // Split the folder path into individual folder IDs, filtering out empty strings
  const folderIds = folderPath.split("/").filter((id) => id.length > 0);

  return { workspaceId, folderIds };
};

// expected to look like: "workspace/{workspaceId}/comment/{commentId}/file/{fileId}".
export const parseWorkspaceCommentEntityPath = (entityPath: string) => {
  const match = entityPath.match(
    /^workspace\/([^/]+)\/comments\/([^/]+)\/file\/([^/]+)$/
  );

  if (!match) {
    throw new Error(`Invalid entityPath format: ${entityPath}`);
  }

  const [, workspaceId, commentId, fileId] = match;

  return { workspaceId, commentId, fileId };
};
